function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { colors, circularFontFamily, breakpoints } from '@airwallex/global';
import { secondaryVariants, colorMap } from './utils';
import { secondaryButtonStyles, colouredButtonStyles, linkButtonStyles } from './styles';

var computePadding = function computePadding(slim) {
  return slim ? 12 : 17;
};

var breakpoint = breakpoints.breakpoint; //Returns a style object

var WebAppStyles = function WebAppStyles(_ref) {
  var disabled = _ref.disabled,
      hasChildren = _ref.hasChildren,
      hasIcon = _ref.hasIcon,
      hasSecondaryIcon = _ref.hasSecondaryIcon,
      link = _ref.link,
      slim = _ref.slim,
      syncing = _ref.syncing,
      noShadow = _ref.noShadow,
      variant = _ref.variant,
      tall = _ref.tall,
      iconPosition = _ref.iconPosition,
      secondaryIconPosition = _ref.secondaryIconPosition,
      dropdownButtonShowMenu = _ref.dropdownButtonShowMenu,
      hover = _ref.hover,
      active = _ref.active,
      responsive = _ref.responsive,
      theme = _ref.theme;
  var secondaryMode = secondaryVariants.includes(variant);
  var hasIconOnLeft = hasIcon && iconPosition !== 'right' || hasSecondaryIcon && secondaryIconPosition !== 'right';
  var hasIconOnRight = hasIcon && iconPosition === 'right' || hasSecondaryIcon;

  var baseTheme = _objectSpread({
    minHeight: tall ? 50 : 40,
    minWidth: tall ? 50 : 40
  }, hasChildren ? {
    fontSize: tall ? 18 : 14,
    fontWeight: tall ? 700 : 500,
    fontFamily: circularFontFamily,
    paddingLeft: hasIconOnLeft ? 0 : computePadding(slim),
    paddingRight: hasIconOnRight ? 0 : computePadding(slim)
  } : {
    paddingLeft: 0,
    paddingRight: 0
  });

  var output = Object.assign({}, baseTheme);

  var buttonStyle = _objectSpread(_objectSpread({}, colorMap(theme)[variant]), {}, {
    link: link,
    variant: variant,
    disabled: disabled,
    noShadow: noShadow,
    dropdownButtonShowMenu: dropdownButtonShowMenu,
    hover: hover,
    active: active,
    theme: theme
  });

  if (secondaryMode) {
    Object.assign(output, secondaryButtonStyles(buttonStyle));
  } else {
    Object.assign(output, colouredButtonStyles(buttonStyle));
  }

  if (link) {
    Object.assign(output, linkButtonStyles(buttonStyle));
  }

  if (disabled) {
    var disabledBase = {
      cursor: 'default',
      boxShadow: 'none',
      '&: hover': {
        color: colors.grey
      }
    };

    if (syncing) {
      Object.assign(output, disabledBase, {
        opacity: 0.95
      });
    } else {
      Object.assign(output, disabledBase, {
        backgroundColor: link ? 'transparent' : colors.softGrey,
        color: colors.grey
      });
    }
  }

  if (responsive) {
    Object.assign(output, _defineProperty({}, breakpoint.s, {
      width: '100%'
    }));
  }

  return output;
};

export default WebAppStyles;